'use client'

// eslint-disable-next-line import/no-duplicates
import { format, isSameYear } from 'date-fns'
// eslint-disable-next-line import/no-duplicates
import ja from 'date-fns/locale/ja'
import {
  CaptionProps,
  DateRange as DateRangeType,
  DayPicker,
  DayPickerProps,
  isDateRange as isDateRangeOrig,
  useNavigation,
} from 'react-day-picker'

import { useExtractSpaceProps } from '../../hooks'
import { Arrow } from '../../icons'
import type { SpaceProps } from '../../themes'
import { Typography } from '../Typography'
import { CaptionContainer, CaptionControlButton, Container } from './styles'

export type CalendarProps = DayPickerProps & SpaceProps
export type DateRange = DateRangeType

// Export isDateRange utility
export const isDateRange = isDateRangeOrig

/**
 * Custom calendar caption component
 */
const CustomCaption = (props: CaptionProps) => {
  const { goToMonth, nextMonth, previousMonth } = useNavigation()
  return (
    <CaptionContainer>
      <CaptionControlButton
        disabled={!previousMonth}
        onClick={() => previousMonth && goToMonth(previousMonth)}
      >
        <Arrow direction="left" />
      </CaptionControlButton>

      <Typography variant="button1">
        {isSameYear(new Date(), props.displayMonth)
          ? format(props.displayMonth, 'MMM', { locale: ja })
          : format(props.displayMonth, 'yyyy年 MMM', { locale: ja })}
      </Typography>

      <CaptionControlButton
        disabled={!nextMonth}
        onClick={() => nextMonth && goToMonth(nextMonth)}
      >
        <Arrow direction="right" />
      </CaptionControlButton>
    </CaptionContainer>
  )
}

/**
 * Calendar component
 */
export const Calendar = ({ id, className, ...rest }: CalendarProps) => {
  const [spaceProps, calendarProps] = useExtractSpaceProps(rest) as [
    SpaceProps,
    DayPickerProps,
  ]

  return (
    <Container {...spaceProps}>
      <DayPicker
        id={id}
        className={className}
        locale={ja}
        components={{
          Caption: CustomCaption,
          ...calendarProps.components,
        }}
        {...calendarProps}
      />
    </Container>
  )
}
